import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DynamicFormComponent} from '@app/shared/components/dynamic-form/dynamic-form.component';
import {MaskedCalendarComponent} from '@app/shared/components/masked-calendar/masked-calendar.component';
import {TranslateModule} from '@ngx-translate/core';
import {PrimeNgModule} from '../prime-ng/prime-ng.module';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PrimeNgModule,
    TranslateModule,
    MaskedCalendarComponent,
    DynamicFormComponent,
  ],
  exports: [DynamicFormComponent],
})
export class DynamicFormModule {}
